export const gradesFivePlusCurriculumPacketsIntroSteps = [
  {
    element: '#resources-title',
    intro: 'Curriculum Packets is where you can download additional support materials. Curriculum Packets contain additional lessons designed to support students in building comprehension, fluency, phrasing, and spelling knowledge.'
  },
  {
    element: '#backButton',
    intro: 'Click here to go back to the Grades 5+ menu page.'
  },
  {
    element: '.student-dropdown-row',
    intro: 'Select a Sub-Category from the dropdown to view the Student or Teacher Version or both.'
  },
  {
    element: '#resourcesTableHeader',
    intro: 'See the Guide for Using Instructional Curriculum Packets and Syllable Types and Vowel Pronunciation files for additional information on how to use the curriculum packets. Scroll until you find the unit Curriculum Packet you want to download. Click the file to download it.'
  }
];